var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFilterFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1 3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v.041c0 .632 0 1.417-.273 2.273-.286.893-.842 1.79-1.84 2.75-.512.492-1.015.856-1.462 1.152-.193.127-.358.232-.506.326-.225.143-.412.262-.602.4-.281.206-.437.368-.533.533-.09.153-.169.379-.169.778V17a1 1 0 0 1-1.488.873l-3.647-2.04a1 1 0 0 1-.512-.873v-3.707c0-.438-.068-.693-.146-.86-.077-.164-.196-.315-.412-.502a9.118 9.118 0 0 0-.636-.484 53.366 53.366 0 0 1-.301-.217 12.75 12.75 0 0 1-1.36-1.126c-.998-.96-1.554-1.857-1.84-2.75C1 4.458 1 3.674 1 3.04V3Z",
  clipRule: "evenodd"
})));
export default SvgIconFilterFilled;